"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchParams = void 0;
var query_string_1 = require("query-string");
var SearchParams = /** @class */ (function () {
    function SearchParams() {
        var currentLocation = window !== undefined ? window.location : '';
        var searchParams = new URL(String(currentLocation)).searchParams;
        this.searchParams = searchParams;
    }
    SearchParams.prototype.set = function (name, value) {
        this.searchParams.set(name, value);
    };
    SearchParams.prototype.delete = function (name) {
        this.searchParams.delete(name);
    };
    SearchParams.prototype.toParsed = function () {
        return (0, query_string_1.parse)(this.searchParams.toString());
    };
    return SearchParams;
}());
exports.SearchParams = SearchParams;
